module.exports = __webpack_public_path__ + "static/media/block.61caecf4.jpg";